import { makeStyles } from '@material-ui/core';

import { buttonErrorBorder, dropdownFieldBase, fieldArrowColor } from '@/styles/inputStyles.ts';

export const useStyles = makeStyles((theme) => ({
    formControl: {
        ...dropdownFieldBase(theme),
        [theme.breakpoints.down('xs')]: {
            marginBottom: 9,
        },
    },
    formControlDisable: {
        ...dropdownFieldBase(theme),
        backgroundColor: theme.palette.action.disabledBackground,
        [theme.breakpoints.down('xs')]: {
            marginBottom: 15,
        },
        '&:hover': {
            backgroundColor: theme.palette.action.disabledBackground,
        },
        '&.Mui-disabled': {
            border: `1px solid ${theme.palette.common.brown} !important`,
        },
    },
    downArrow: {
        color: fieldArrowColor(theme),
        marginRight: 15,
    },
    menuItem: {
        fontWeight: theme.weight.heading,
        fontSize: '1rem',
        color: theme.palette.common.darkGrey,
        textTransform: 'none',
    },
    ButtonMainClass: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    ButtonTextMainClass: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.weight.body,
        fontSize: '0.875rem',
        color: theme.palette.common.darkGrey,
        textTransform: 'none',
        padding: 0,
        marginLeft: 3,
    },
    disabledText: {
        color: theme.palette.common.midGrey,
    },
    dropDownTextClass: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.weight.body,
        fontSize: '1rem',
        color: theme.palette.common.darkGrey,
        textTransform: 'none',
    },
    dropDownTextClassDisabled: {
        color: theme.palette.common.midGrey,
    },
    MenuButtonMainClass: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 15,
        justifyContent: 'space-between',
        paddingRight: 15,
        marginBottom: 10,
    },
    OpendownArrow: {
        marginTop: 2,
        color: fieldArrowColor(theme),
        marginRight: 15,
    },
    errorBorder: {
        ...buttonErrorBorder,
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: theme.palette.common.red,
        marginBottom: 5,
        marginTop: '0.3em',

        [theme.breakpoints.down('xs')]: {
            marginTop: '-0.4em',
        },
    },
    requiredStar: {
        color: '#D32F2F',
        fontSize: '1.2em',
    },
}));
